export default [
  {
    text: 'Свободный',
    value: 'free',
  },
  {
    text: 'Пропускная система',
    value: 'passSystem',
  },
];
